module.exports = __webpack_public_path__ + "static/img/tscar1.2964677.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tscar1.png
// module id = dpGW
// module chunks = 1